import { Chip } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { SelectAutocomplete, CustomDatePicker } from '@/components';

import { FiltersSectionProps } from './FiltersSection.types';
import './FiltersSection.css';
/**
 * Renders filter controls for orders search functionality
 * Provides hierarchical filtering by division, legal entity, and date range with order number management

 */
export function FiltersSection({
  filters,
  activeFilters,
  filterOptions,
  canGenerateOrders,
  onFilterChange,
  onRemoveFilter,
  onChangeOrderNumber
}: FiltersSectionProps): JSX.Element {
  const divisionOptions = filterOptions.divisions.map(d => d.name);

  const legalEntityOptions = filterOptions.legal_entities.map(e => e.name);
  const divisionValue = filters.division_id
    ? filterOptions.divisions.find(d => d.id === filters.division_id)?.name || ''
    : '';

  const dateValue = (value?: string) => {
    return value ? new Date(value) : null;
  };

  const isClearButton = Array.isArray(filters.legal_entity_id) && filters.legal_entity_id.length > 0;

  const handleOnChangeDivision = (value: string) => {
    const division = filterOptions.divisions.find(d => d.name === value);
    onFilterChange('division_id', division?.id);
  };

  const handleOnLegalEntityChange = (value: string) => {
    const entity = filterOptions.legal_entities.find(e => e.name === value);
    if (entity) {
      const currentIds = Array.isArray(filters.legal_entity_id)
        ? filters.legal_entity_id.filter((id): id is number => typeof id === 'number')
        : [];
      const newIds = currentIds.includes(entity.id) ? currentIds : [...currentIds, entity.id];
      onFilterChange('legal_entity_id', newIds);
    }
  };

  const handleDateChange = (key: 'date_from' | 'date_to') => (value: string | Date | null) => {
    onFilterChange(key, (value as string) || '');
  };

  const handleOnLegalEntityClear = () => {
    onFilterChange('legal_entity_id', []);
  };

  const handleOnRemoveFilter = (key: string, id?: number) => () => {
    onRemoveFilter(key, id);
  };

  return (
    <div className="filter-section">
      <div className="filter-card">
        <div className="filter-row">
          <div className="form-field-group">
            <label className="field-label">Дивізіони</label>
            <SelectAutocomplete
              placeholder="Оберіть дивізіон..."
              options={divisionOptions}
              value={divisionValue}
              onChange={handleOnChangeDivision}
            />
          </div>

          <div className="form-field-group">
            <label className="field-label">Юр. особи</label>
            <SelectAutocomplete
              placeholder="Оберіть юр. особи..."
              options={legalEntityOptions}
              disabled={!filters.division_id}
              value={''}
              showClearButton={isClearButton}
              onClear={handleOnLegalEntityClear}
              onChange={handleOnLegalEntityChange}
            />
          </div>

          <div className="form-field-group">
            <label className="field-label">Дата з</label>
            <CustomDatePicker
              value={dateValue(filters.date_from)}
              onChange={handleDateChange('date_from')}
              format="dd.MM.yyyy"
              outputFormat="date"
            />
          </div>

          <div className="form-field-group">
            <label className="field-label">Дата по</label>
            <CustomDatePicker
              value={dateValue(filters.date_to)}
              onChange={handleDateChange('date_to')}
              format="dd.MM.yyyy"
              outputFormat="date"
            />
          </div>
        </div>

        {activeFilters.length > 0 && (
          <div className="active-filters">
            {activeFilters.map((filter: any, index) => (
              <Chip
                key={`${filter.key}-${index}`}
                label={filter.value}
                deleteIcon={<Cancel />}
                className={`orders-filter-chip ${filter.key}`}
                onDelete={handleOnRemoveFilter(filter.key, filter.id)}
              />
            ))}
          </div>
        )}

        <div className="action-buttons">
          {canGenerateOrders && (
            <button className="action-btn" onClick={onChangeOrderNumber}>
              Змінити порядковий номер
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
